import React from 'react';
import { __ } from 'i18n/index';

function imageOf(character) {
	return character.stock_icon_url || character.image_url;
}

// A Random pick drawn with a small picture of what it landed on at its corner,
// so everyone can tell the character was random. Without a roll it draws only
// the pick, exactly as before.
export default function RolledCharacter({ rolledCharacter, className = '', children }) {
	if(!rolledCharacter) {
		return children;
	}
	const label = __('Landed on %s', rolledCharacter.name);
	return (
		<span className={`rolled-character ${className}`}>
			{children}
			<img className='rolled-character__badge' src={imageOf(rolledCharacter)} alt={label} title={label} />
		</span>
	);
}
